import request from "../../util/request";

export function qrCodeUrlList(model) {
    return request({
        url: '/api-admin/qr_code/url/config/list',
        method: 'post',
        data: model
    })
}